/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import {
  Box,
  Button,
  FlexContainer,
  Loader,
  Text,
  theme,
} from "@nordcloud/gnui";
import {
  KeyValuesInput,
  useEstateResourceCountQuery,
} from "~/generated/graphql";

export type Filters = {
  cloudAccount?: string[];
  resourceGroup?: string[];
  projectId?: string[];
  tags?: KeyValuesInput[];
  type?: string[];
  subtype?: string[];
};

type Props = {
  onClick: () => void;
  filters: Filters;
};

function DiscoveredRecordsInner({ onClick, filters }: Props) {
  const { data, loading } = useEstateResourceCountQuery({
    variables: {
      filter: filters,
    },
    errorPolicy: "all",
  });

  const count = data?.estateResourceCountV2 ?? 0;

  return (
    <>
      <Box
        boxStyle="lightGrey"
        innerSpacing="spacing02"
        mb={theme.spacing.spacing07}
      >
        <FlexContainer>
          <Button
            type="button"
            severity="low"
            my={theme.spacing.spacing02}
            icon="plus"
            onClick={onClick}
          >
            Add Condition
          </Button>
          <div css={{ marginLeft: theme.spacing.spacing07 }}>
            <Text color={theme.color.text.text02} size="sm" tag="div">
              Expected amount
            </Text>
            <Text tag="div" weight="medium">
              ≈ {loading ? <Loader inContent /> : count} estate records
            </Text>
          </div>
        </FlexContainer>
      </Box>
    </>
  );
}

export const DiscoveredRecords = React.memo(DiscoveredRecordsInner);
